import ContentLoader from "react-content-loader";

const ImageThumbnailLoader = (props) => (
  <ContentLoader
    rtl
    speed={4}
    width={100}
    height={100}
    viewBox="0 0 100 100"
    backgroundColor="#f6f5f4"
    foregroundColor="#deddda"
    {...props}
  >
    <rect x="0" y="0" rx="5" ry="5" width="100" height="100" />
  </ContentLoader>
);

export default ImageThumbnailLoader;
